import axios from 'axios'
import log from '../log/log'
import router from '../../router/routers'
import {clearToast, failToast, loading} from '../../util/util'
import storeRepository from "../store/StoreRepository"
import userRepository from "../store/UserRepository"
import bluetoothRepository from "../bluetooth/BluetoothRepository"

const CODE_SUCCESS = 200;
const CODE_EXPIRED = 401;

const TOKEN      = "front-token"
const ASCRIPTION = "ASCRIPTION"
const TIME_ZONE  = "timeZone"
const LANGUAGE   = "languages"
const SOURCE     = "2"
const baseURL    = process.env.NODE_ENV === 'development' ? null : 'https://app.unicoreus.com/supplement/'
const api        = axios.create({
        baseURL,
        timeout: 10000
    }
);

api.interceptors.request.use(function (config) {
    if (config.isShowLoading) {
        // log(config)
        loading('Loading...')
    }
    if (storeRepository.token) {
        config.headers[TOKEN] = storeRepository.token
    }
    if (location.hostname === 'app.unicoreus.com') {
        config.headers[ASCRIPTION] = 4
    } else if (location.hostname === 'dimeone.unicoreus.com') {
        config.headers[ASCRIPTION] = 5
    } else {
        config.headers[ASCRIPTION] = 4
    }
    config.headers[SOURCE]   = 2
    config.headers[LANGUAGE] = 0
    let timezone             = new Date().getTimezoneOffset() / -60
    if (timezone > 0) {
        timezone = `+${timezone}:00`
    } else {
        timezone = `${timezone}:00`
    }
    config.headers[TIME_ZONE] = timezone
    return config;
}, function (error) {

    return Promise.reject(error);
});

// Add a response interceptor
api.interceptors.response.use(function (response) {
    const {code} = response.data;
    if (code === CODE_SUCCESS) {
        clearToast()
        return response.data.data;
    } else if (code === CODE_EXPIRED) {
        failToast(response.data.message);
        userRepository.logout()
        return Promise.reject(response.data.message);
    } else {
        failToast(response.data.message);
        return Promise.reject(response.data.message);
    }
}, function (error) {
    return Promise.reject(error);
});


class ApiService {
    async splashPage({success, fail}) {
        try {
            const response = await this._postQuery('front/user/findSystemSetup');
            log("splashPage = " + response);
            success(response)
        } catch (e) {
            log(e);
            fail(e)
        }
    }

    async login(data) {
        return await this._postQuery('front/user/doLogin', data, true)
    }

    async register(data) {
        return await this._postQuery('front/user/addUser', data, true)
    }

    async cartridgeInfo(data) {
        return await this._getBody('front/device/smokeRecord', data)
    }

    async deviceConnection(data) {
        return await this._postQuery('front/device/deviceConnection', data)
    }

    async syncSmokeData(data) {
        return await this._postBody('front/cartridge/synchronousData', data)
    }

    async operatingModeList(data) {
        return await this._getBody("front/device/operatingModeList", data)
    }

    async sendEmail(data) {
        data.ascription = 5
        return await this._postQuery("front/user/sendEmail", data, true)
    }


    async sendEmailToRegister(data) {
        data.ascription = 5
        return await this._postQuery("front/user/sendEmailToRegister", data, true)
    }


    async verifyCode(data) {
        data.ascription = 5
        return await this._getBody("front/user/verificationCode", data, true)
    }


    async resetPassword(data) {
        data.ascription = 5
        return await this._postQuery("front/user/retrievePassword", data, true)
    }

    async uploadFile(data) {
        return await api.post('front/user/uploadFile', data, {
            headers: {
                'Content-Type': 'multipart/form-data;charset=UTF-8'
            }
        })
    }

    async getUserInfo() {
        return await api.get('front/user/findUser')
    }

    async messageList(data) {
        return await this._getBody('front/messages/list', data)
    }

    async messageDetail(data) {
        return await this._getBody('front/messages/findById', data)
    }

    async isUnreadMessage() {
        return await api.get('front/messages/findByReadCount')
    }


    async findUser() {
        return await api.get('front/user/findUser')
    }

    /**
     * 我的faq问答
     * @returns {Promise<void>}
     */
    async mineFaq() {
        return await api.get('front/user/commonProblemList')
    }


    /**
     * 膏类型
     * @returns {Promise<void>}
     */
    async concentrateTypeList(data) {
        return await this._getBody('front/cartridge/selectAllProblemList', data)
    }


    /**
     * 保存diy曲线
     * @returns {Promise<void>}
     */
    async saveCustomDiyTemperature(data) {
        return await this._postQuery('front/cartridge/saveCustomModel', data)
    }


    /**
     * 烟弹faq
     * @param data
     * @returns {Promise<*>}
     */
    async consulationList(data) {
        return await this._getBody("front/smokeRecord/consultationList", data)
    }


    /**
     *
     * @param macAddress 设备蓝牙地址
     * @param deviceName 设备名称
     * @returns {Promise<void>}
     */
    async getDeviceNameFromServer(macAddress, deviceName) {
        return await this._getBody("front/device/findByDeviceNumber", {
            deviceNumber: macAddress,
            deviceType  : deviceName,
        })
    }

    /**
     * 绑定设备
     * @param macAddress 蓝牙地址
     * @returns {Promise<void>}
     */
    async bindDevice(macAddress) {
        return await this._postQuery("front/device/bindingDevice", {
            deviceNumber: macAddress
        })
    }

    /**
     * 获取我已经绑定的设备
     * @returns {Promise<*>}
     */
    async myDevices() {
        return await this._getBody("front/device/selectMyDevices")
    }

    /**
     * 修改已绑定设备名称
     * @param deviceId
     * @param deviceName
     * @returns {Promise<*>}
     */
    async modifyDeviceName(deviceId, deviceName) {
        return await this._postQuery("front/device/updateById", {
            id           : deviceId,
            deviceName,
            isShowLoading: true
        })
    }

    /**
     * 解绑已经绑定的设备
     * @param deviceId
     * @returns {Promise<*>}
     */
    async unbindDevice(deviceId) {
        return await this._postQuery("front/device/untieDevice", {
            id: deviceId
        })
    }

    async synchronizeTime(macAddress, deviceType, encryptionType) {
        return await this._postQuery("front/device/synchronizeTime", {
            deviceNumber: macAddress,
            deviceType,
            encryptionType
        })
    }

    async queryDeviceBind(macAddress, deviceType) {
        return await this._postQuery("front/device/findByDeviceNumber", {
            deviceNumber: macAddress,
            device
        })
    }


    async modifyProfile(data) {
        return await this._postQuery('front/user/update', data, true)
    }


    /**
     * 查询所有烟油类型的
     */
    async getSmokeOilType() {
        return await this._getBody('front/device/selectTypeList')
    }


    /**
     * 新版本 我的记录树状图表(带曲线版本)
     */
    async selectChartLineHistogram(status, oilType, startTime, pageNum = 1, pageSize = 10) {
        return await this._getBody('front/cartridge/selectDayWeekMonthHistograms', {
            status, typeStatus: oilType, startTime, pageNum, pageSize
        })
    }

    /**
     * 折线图版本我的记录
     */
    async chartLineSmokingTimeRecord(status, oilType, startTime, currentTime) {
        return await this._getBody('front/cartridge/selectLineChart', {
            status, typeStatus: oilType, startTime, currentTime
        })

    }

    /**
     * 查询调查问卷列表
     */
    async questionList() {
        return await this._getBody('front/userReply/selectAllProblem')
    }


    /**
     * 硬件设备OTA升级检查
     */
    async otaCheck(hwVersion, cartridgeFlag) {
        return await this._getBody('front/device/selectLatestVersion', {
            hardware         : hwVersion,
            otaIdentification: cartridgeFlag
        }, true)
    }


    /**
     * 查询调查问卷列表
     */
    async saveAnswer(answer) {
        return await this._postBody('front/userReply/saveFillInTheAnswer', answer)
    }

    async _postQuery(url, data = null, isShowLoading = false) {
        return await api.post(url, null, {params: data, isShowLoading})
    }

    async _postBody(url, data = null) {
        return await api.post(url, data)
    }

    async _getBody(url, data = null, isShowLoading = false) {
        return await api.get(url, {params: data, isShowLoading})
    }
}

const apiService = new ApiService();
export default apiService;
